import runAfterPageLoad from "../runAfterPageLoad";

export default function initializeAutocomplete(
  inputFieldSelector,
  model,
  field,
  all = false
) {
  runAfterPageLoad(() => {
    const groupId = $(inputFieldSelector).data("group-id");
    const locale = $(inputFieldSelector).data("locale");

    $(inputFieldSelector).autocomplete({
      source: `/api/groups/autocomplete?group_id=${groupId}&model=${model}&field=${field}&all=${all}&locale=${locale}`,
      minLength: 2,
      select(event, ui) {
        // to update value attribute, both are needed
        $(event.target).attr("value", ui.item.value);
        $(event.target).val(ui.item.value);
        const form = $(event.target).closest(".filter-form");
        form.submit();
        return false;
      },
    });
  });
}
